import type { ItineraryConstraint$options } from '$houdini';
import * as m from '$paraglide/messages';

const tripConstraintLabel: Record<ItineraryConstraint$options, () => string> = {
	NONE: m.itinerary__options__constraints__none,
	NO_BORDER_CROSSING: m.itinerary__options__constraints__no_border_crossing,
	NO_FERRY: m.itinerary__options__constraints__no_ferry,
	NO_LOW_EMISSION_ZONE: m.itinerary__options__constraints__no_low_emission_zone,
	NO_MOTORWAY: m.itinerary__options__constraints__no_motorway,
	NO_TOLL: m.itinerary__options__constraints__no_toll,
	NO_VIGNETTE: m.itinerary__options__constraints__no_vignette,
};
export function tripConstraints(constraint: ItineraryConstraint$options): string {
	return tripConstraintLabel[constraint]();
}
